import React from "react";
import { Users, Bell, Package } from "lucide-react";
import { Placeholder } from "./Placeholder";

const steps = [
  {
    n: "01",
    icon: Users,
    title: "Add the people you care about",
    body:
      "Build your Circle, relationship, interests, important dates. Birthdays, anniversaries, Mother's and Father's Day, the cultural moments that matter to your family.",
    placeholder: "Add to Circle, relationship, interests, dates",
    image: "/assets/your_circle.jpeg",
  },
  {
    n: "02",
    icon: Bell,
    title: "Liéa tells you when it matters",
    body:
      "Proactive reminders arrive on WhatsApp and in-app, paired with recommended gifts matched to that person's actual interests and the occasion.",
    placeholder: "Upcoming occasion alert with AI picks",
    image: "/assets/gift.jpeg",
  },
  {
    n: "03",
    icon: Package,
    title: "A local vendor makes it happen",
    body:
      "Your order goes to the vendor in the recipient's country, who prepares and Liéa arranges to have it delivered or held for pickup.",
    placeholder: "Order confirmed with local vendor",
    image: "/assets/vendor.jpeg",
  },
];

export const HowItWorks = () => {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="liea-section"
      style={{ background: "var(--liea-paper)" }}
    >
      <div className="liea-container">
        <div className="max-w-2xl">
          <span className="liea-eyebrow">How Liéa works</span>
          <h2 className="mt-4 text-[36px] md:text-[48px] lg:text-[56px] leading-[1.05] tracking-tight">
            Three steps,{" "}
            <em
              style={{
                fontStyle: "italic",
                color: "var(--liea-forest)",
              }}
            >
              one thoughtful gesture
            </em>
            <span style={{ color: "var(--liea-terracotta)" }}>.</span>
          </h2>
          <p
            className="mt-5 text-base md:text-lg max-w-xl leading-relaxed"
            style={{ color: "var(--liea-warm-grey)" }}
          >
            Whether you&rsquo;re sending or fulfilling, Liéa keeps the flow
            simple and the meaning intact.
          </p>
        </div>

        <div className="mt-14 md:mt-20 grid md:grid-cols-3 gap-8 md:gap-6 lg:gap-10">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.n}
                data-testid={`step-card-${i + 1}`}
                className="relative flex flex-col"
              >
                <div className="flex items-baseline gap-4">
                  <span className="liea-step-num">{s.n}</span>
                  <div
                    className="w-10 h-10 rounded-full flex items-center justify-center"
                    style={{
                      background: "rgba(64, 83, 68, 0.08)",
                      color: "var(--liea-forest)",
                    }}
                  >
                    <Icon size={18} strokeWidth={1.7} />
                  </div>
                </div>

                <h3 className="mt-5 text-[24px] md:text-[26px] leading-tight">
                  {s.title}
                </h3>
                <p
                  className="mt-3 text-[15px] leading-relaxed"
                  style={{ color: "var(--liea-warm-grey)" }}
                >
                  {s.body}
                </p>

                <div className="mt-7">
                  {s.image ? (
                    <img
                      src={s.image}
                      alt={s.placeholder}
                      style={{ width: "100%", borderRadius: "16px", display: "block" }}
                    />
                  ) : (
                    <Placeholder
                      testId={`step-placeholder-${i + 1}`}
                      label={s.placeholder}
                      aspect="4/3"
                    />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
